import { render, staticRenderFns } from "./proReviewDemographics.vue?vue&type=template&id=4a6d8592&"
import script from "./proReviewDemographics.vue?vue&type=script&lang=js&"
export * from "./proReviewDemographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports